'use strict';
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Make class/function able to be invoked without new
 * @param {function} DataType
 */
function invokable(DataType) {
    return new Proxy(DataType, {
        // STRING(255)
        apply: function (target, thisArg, args) {
            return new (target.bind.apply(target, __spreadArray([void 0], __read(args), false)))();
        },
        // new STRING(255)
        construct: function (target, args) {
            return new (target.bind.apply(target, __spreadArray([void 0], __read(args), false)))();
        },
        // INTEGER.UNSIGNED
        get: function (target, p) {
            // ref: https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Function/length
            // The length property indicates the number of parameters expected by the function.
            // invokable INTEGER.toSqlString() will default to return "INTEGER(1)"
            return target.hasOwnProperty(p) ? target[p] : new target()[p];
        }
    });
}
;
module.exports = invokable;
//# sourceMappingURL=invokable.js.map